import { SelectedDossierProvider, useDefaultContextActions } from '@europrocurement/l2d-modules';
import { Container } from '@mui/material';
import React from 'react';
import { useDumbActionsContext } from '@europrocurement/flexy-components';
import { DossierAddFormality } from '../../components';

const AddFormality: React.FunctionComponent = function () {
    const { backContextActions } = useDefaultContextActions();
    useDumbActionsContext(backContextActions);

    return (
        <SelectedDossierProvider>
            <Container maxWidth="md">
                <DossierAddFormality />
            </Container>
        </SelectedDossierProvider>
    );
};

export default AddFormality;
